var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("hamburger", {
        staticClass: "hamburger-container",
        attrs: { id: "hamburger-container", "is-active": _vm.sidebar.opened },
        on: { toggleClick: _vm.toggleSideBar },
      }),
      _vm._v(" "),
      _c("breadcrumb", {
        staticClass: "breadcrumb-container",
        attrs: { id: "breadcrumb-container" },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right-menu" },
        [
          _vm.device !== "mobile"
            ? [
                _c("lang-select", {
                  staticClass: "right-menu-item hover-effect",
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-dropdown",
            {
              staticClass: "avatar-container right-menu-item hover-effect",
              attrs: { trigger: "click", size: "medium" },
            },
            [
              _c(
                "div",
                { staticClass: "avatar-wrapper" },
                [
                  _vm.avatar
                    ? _c("MyImage", {
                        staticClass: "user-avatar",
                        attrs: { src: _vm.avatar },
                      })
                    : _c("img", {
                        staticClass: "user-avatar",
                        attrs: {
                          src: require("@/assets/common/avatar.png"),
                          alt: "",
                        },
                      }),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "user-arrow",
                    attrs: {
                      src: require("@/assets/common/arrow-down.png"),
                      alt: "",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                {
                  staticClass: "menu-dropdown",
                  attrs: { slot: "dropdown" },
                  slot: "dropdown",
                },
                [
                  _c("el-dropdown-item", { attrs: { disabled: "" } }, [
                    _c("span", { staticClass: "user-name" }, [
                      _vm._v(_vm._s(_vm.name)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.$store.getters.roles && _vm.$store.getters.roles[0]
                    ? _c(
                        "el-dropdown-item",
                        { attrs: { divided: "", disabled: "" } },
                        [
                          _c("span", { staticClass: "user-role" }, [
                            _vm._v(
                              _vm._s(
                                _vm.getRoleName(_vm.$store.getters.roles[0])
                              )
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.functions["taskList"] &&
                  _vm.functions["taskList"].includes("LIST")
                    ? _c(
                        "router-link",
                        { attrs: { to: "/taskModule/taskList" } },
                        [
                          _c("el-dropdown-item", { attrs: { divided: "" } }, [
                            _vm._v(_vm._s(_vm.$t("navbar.taskList"))),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.functions["likeCommentList"] &&
                  _vm.functions["likeCommentList"].includes("LIST")
                    ? _c(
                        "router-link",
                        { attrs: { to: "/likeCommentModule/likeCommentList" } },
                        [
                          _c("el-dropdown-item", { attrs: { divided: "" } }, [
                            _vm._v(_vm._s(_vm.$t("navbar.likeCommentList"))),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    { attrs: { to: "/" } },
                    [
                      _c("el-dropdown-item", { attrs: { divided: "" } }, [
                        _vm._v(_vm._s(_vm.$t("navbar.dashboard"))),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.$store.getters.userInfo.roleCodes &&
                  _vm.$store.getters.userInfo.roleCodes.length > 1
                    ? _c(
                        "el-dropdown-item",
                        {
                          attrs: { divided: "" },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.changeRole($event)
                            },
                          },
                        },
                        [
                          _c("span", { staticStyle: { display: "block" } }, [
                            _vm._v(_vm._s(_vm.$t("navbar.changeRole"))),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: { divided: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.logout($event)
                        },
                      },
                    },
                    [
                      _c("span", { staticStyle: { display: "block" } }, [
                        _vm._v(_vm._s(_vm.$t("navbar.logOut"))),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("Modifypass", {
            attrs: { "is-show": _vm.isShowModelModifypass },
            on: {
              "update:isShow": function ($event) {
                _vm.isShowModelModifypass = $event
              },
              "update:is-show": function ($event) {
                _vm.isShowModelModifypass = $event
              },
            },
          }),
          _vm._v(" "),
          _c("ChangeRole", {
            attrs: { "is-show": _vm.isShowModelChangeRole },
            on: {
              "update:isShow": function ($event) {
                _vm.isShowModelChangeRole = $event
              },
              "update:is-show": function ($event) {
                _vm.isShowModelChangeRole = $event
              },
            },
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }